const config = {
  rowSelection: false,
  columns: [
    {
      title: '财务主体',
      dataIndex: 'financialOrgName',
      width: 190,
      ellipsis: true,
    },
    {
      title: '来源订单号',
      dataIndex: 'sourceOrderNo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '来源主合同号',
      dataIndex: 'sourceContractNo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '来源需求标签',
      dataIndex: 'sourceOrderBizTagName',
      width: 140,
    },
    {
      title: '客户名称',
      dataIndex: 'sourceOrderCustomerName',
      width: 120,
    },
    {
      title: '受益订单号',
      dataIndex: 'targetOrderNo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '受益主合同号',
      dataIndex: 'targetContractNo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '受益需求标签',
      dataIndex: 'targetOrderBizTagName',
      width: 140
    },
    {
      title: '优惠券名称',
      dataIndex: 'couponName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '优惠券ID',
      dataIndex: 'id',
      width: 150,
      ellipsis: true,
    },
    {
      title: '优惠券活动名称',
      dataIndex: 'activityName',
      width: 160,
      ellipsis: true,
    },
    {
      title: '优惠券状态',
      dataIndex: 'couponStatusName',
      width: 120
    },
    {
      title: '预计抵扣金额',
      dataIndex: 'deductionValue',
      width: 120
    },
    {
      title: '实际抵扣金额',
      dataIndex: 'useValue',
      width: 120
    },
    {
      title: '生效日期',
      dataIndex: 'effectiveTime',
      itemType: 'dateTime',
      width: 160
    },
     {
      title: '使用日期',
      dataIndex: 'useTime',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '核销日期',
      dataIndex: 'verificationTime',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '失效日期',
      dataIndex: 'invalidTime',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '过期日期',
      dataIndex: 'expiredTime',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '金蝶转款状态',
      dataIndex: 'kdSyncStatusName',
      width: 120
    },
    {
      title: '金蝶退款记录单号',
      dataIndex: 'refundBillNo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 180,
      render: 'renderOperate',
      fixed: 'right'
    },
  ],
  search: [
    {
      name: 'financialOrgName',
      label: '财务主体',
    },
    {
      name: 'sourceOrderNo',
      label: '来源订单号',
    },
    {
      name: 'sourceContractNo',
      label: '来源主合同号',
    },
    {
      name: 'sourceOrderCustomerNameStartWith',
      label: '客户名称',
    },
    {
      name: 'sourceOrderBizTagList',
      label: '来源需求标签',
      itemType: 'select',
      data: 'bizOpTypeList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'couponStatusList',
      label: '优惠券状态',
      itemType: 'select',
      data: 'couponStatusList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'targetOrderNo',
      label: '受益订单号',
    },
    {
      name: 'targetContractNo',
      label: '受益主合同号',
    },
    {
      name: 'targetOrderBizTagList',
      label: '受益需求标签',
      itemType: 'select',
      data: 'bizOpTypeList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'couponId',
      label: '优惠券ID',
    },
    // {
    //   name: 'receivableDate',
    //   label: '应收日期',
    //   itemType: 'autoDate',
    //   allowClear: 'true'
    // }
    {
      name: 'kdSyncStatusList',
      label: '金蝶转款状态',
      itemType: 'select',
      data: 'kdSyncStatusList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'refundBillNo',
      label: '金蝶退款记录单号',
    },
  ],
  footer: [
     { label: '导出', render: 'exportRender' },
  ],
  // batchActions: [
  //   {
  //     label: '合并收款',
  //     type: 'primary',
  //     auth: 'ReceivableListMergeReceipts',
  //     events: ['onClick:onMergeReceipts'],
  //   }
  // ]
}

export default config
